import { render, staticRenderFns } from "./stockLimitListAction.vue?vue&type=template&id=09abded7&scoped=true"
import script from "./stockLimitListAction.vue?vue&type=script&lang=js"
export * from "./stockLimitListAction.vue?vue&type=script&lang=js"
import style0 from "./stockLimitListAction.vue?vue&type=style&index=0&id=09abded7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09abded7",
  null
  
)

export default component.exports